import { getTracerModules } from '@apptracer/sdk/lite';

import { tokenManager } from '../utils';

import { packageName, widgetApi } from '../../config';

const tracerLog = getTracerModules(packageName).log;

export const downloadFileApi = (url: string, name: string) => {
  // Фикс проблемы с именами файлов виду name #anything.anything
  url = encodeURI(`${widgetApi}/filestore/${url}`);
  url = url.replace(/#/g, '%23');

  const token = tokenManager.getToken();

  fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        tracerLog?.log(`url: ${url}`);

        throw new Error('Не удалось скачать файл');
      }
      return response.blob();
    })
    .then((blob) => {
      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = objectUrl;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(objectUrl);
    })
    .catch((error) => {
      throw new Error(error);
    });
};
